module.exports = __webpack_public_path__ + "static/img/title.aaac08de.png";